/*
 * Tencent is pleased to support the open source community by making
 * 蓝鲸智云PaaS平台 (BlueKing PaaS) available.
 *
 * Copyright (C) 2021 THL A29 Limited, a Tencent company.  All rights reserved.
 *
 * 蓝鲸智云PaaS平台 (BlueKing PaaS) is licensed under the MIT License.
 *
 * License for 蓝鲸智云PaaS平台 (BlueKing PaaS):
 *
 * ---------------------------------------------------
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
 * documentation files (the "Software"), to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and
 * to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of
 * the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
 * THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF
 * CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */

import { h } from 'vue';

import { commonSVGProps } from '../common';
export const CopyIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-copy-icon': true,
    },
  },
  [
    h('path', {
      d: 'M672 704L672 832C672 867.346224 643.346224 896 608 896L192 896C156.653776 896 128 867.346224 128 832L128 384C128 348.653776 156.653776 320 192 320L352 320 352 216.88888896C352 168.2420416 389.7269152 128 437.3333344 128L810.6666656 128C858.2730848 128 896 168.2420416 896 216.88888896L896 615.1111104C896 663.7579584 858.2730848 704 810.6666656 704L672 704ZM608 384L192 384 192 832 608 832 608 384ZM672 640L810.6666656 640C821.9706208 640 832 629.3019968 832 615.1111104L832 216.88888896C832 202.69800448 821.9706208 192 810.6666656 192L437.3333344 192C426.0293792 192 416 202.69800448 416 216.88888896L416 320 608 320C643.346224 320 672 348.653776 672 384L672 640Z',
    }),
  ],
);
export const CiteIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-cite-icon': true,
    },
  },
  [
    h('path', {
      fillRule: 'evenodd',
      d: 'M642.2717056 192L642.2717056 256 416 256C309.961328 256 224 341.961328 224 448 224 554.038672 309.961328 640 416 640L771.712 640 640 509.52 686 464 896 672 686 880 640 834.48 771.712 704 416 704C277.28274368 704 164.33462816 593.6691904 160.12181824 455.9737376L160 448C160 306.615104 274.615104 192 416 192L642.2717056 192Z',
    }),
  ],
);
export const RebuildIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-rebuild-icon': true,
    },
  },
  [
    h('g', null, [
      h('path', {
        d: 'M844.0772288 379.89662848C860.4577216 421.55369728 869.3925312 467.67402368 869.3925312 512.3065977599999 869.3925312 710.17767424 708.56589312 869.3671872 512 869.3671872 427.1192736 869.3671872 345.21681792000004 839.6121408 281.18398848000004 784.5652992L352.66249536 784.5652992 352.66249536 725.05519936 184.39017791999999 725.05519936 184.39017791999999 891.6834752 243.9556 891.6834752 243.9556 830.6856256C419.67359552 977.97312 683.2505888 955.656832 830.675008 780.1020416 931.936224 659.59409088 955.7623936 494.453568 894.70784 350.14157952L844.0772288 379.89662848Z',
      }),
      h('path', {
        d: 'M179.9227712 644.7165664C163.54227967999998 603.0594976 154.607466496 556.9391711999999 154.607466496 512.3065977599999 154.607466496 314.43552064 315.43410688 155.246007232 512 155.246007232 596.8807264 155.246007232 678.78318208 185.00105664 742.8160128 240.0478976L671.33750464 240.0478976 671.33750464 299.55799551999996 839.609824 299.55799551999996 839.609824 132.92972032 780.0444032 132.92972032 780.0444032 193.9275712C604.3264044800001 45.152325248 340.7494112 68.956364544 193.32499072000002 244.51115456 92.0637731136 365.019104 68.237604224 530.15962688 129.292162048 674.47161536L179.9227712 644.7165664Z',
      }),
    ]),
  ],
);
export const ShareIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-share-icon': true,
    },
  },
  [
    h('path', {
      d: 'M954.2973504 473.91614016L566.9315014399999 132.1331402944C556.1972671999999 122.695581056 539.74588608 130.46066144 539.74588608 144.915657216L539.74588608 345.37419392000004C539.74588608 354.33390208000003 532.8619750400001 361.86005696 524.11124032 362.21844544 299.85908159999997 370.46137664 111.309920448 537.11194816 71.639923584 765.6442368L64.28930653056 808.0535232C61.3723950016 824.5393856 81.207393408 834.813184 92.525010176 822.6279808L121.46077254400001 791.328736C226.1195584 677.95856 371.4984288 614.28490048 523.29450496 614.8822144000001 532.39526912 614.8822144000001 539.86256256 622.40836928 539.86256256 631.72646592L539.86256256 827.8843456C539.86256256 842.3393408 556.43062016 850.104416 567.04817792 840.6668608L954.4140288 499.48117376C961.8813248 492.67179584 961.8813248 480.60605568 954.2973504 473.91614016ZM157.39712256 678.9142624C222.73594112 524.92674496 371.61510528 421.233056 541.7293862399999 421.233056L581.39938304 421.233056C590.5001472 421.233056 597.85076416 413.70690112 597.85076416 404.38880512L597.85076416 237.97715904 879.624416 486.69865664 597.85076416 734.82284096 597.85076416 572.59239232C597.85076416 563.27429568 590.5001472 555.7481408 581.39938304 555.7481408L545.3463564799999 555.7481408C404.98457344 550.01392768 268.23976064 594.21515456 157.39712256 678.9142624Z',
    }),
  ],
);
export const LikeIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-like-icon': true,
    },
  },
  [
    h('path', {
      'fill-rule': 'evenodd',
      d: 'M192 448.9971328L192 896 128 896 128 448.9971328 192 448.9971328ZM448 128C492.4018176 134.634696 524.4018176 145.30136288 544 160 586.6666656 192 608 234.66666656 608 288L608 384 843.5169184 384C849.3750016 384 855.2053472 384.8042912 860.8446368 386.3903392 894.8707136 395.9601728 914.6964128 431.3016416 905.1265792 465.3277184L797.1265792 849.3277184C789.3635424 876.9296288 764.1897344 896 735.5169184 896L288 896 288 448 448 128ZM483.008 201.024L352 463.04 352 832 735.5169184 832 843.5169184 448 544 448 544 288C544 254.81113408 532.1510912 231.11331968 505.6 211.2 501.3777696 208.03332736 494.5455392 204.77854912 485.19824 201.68239552L483.008 201.024Z',
    }),
  ],
);
export const UnLikeIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-un-like-icon': true,
    },
  },
  [
    h('path', {
      d: 'M192 575.0028672000001L192 128 128 128 128 575.0028672000001 192 575.0028672000001ZM448 896C492.4018176 889.365304 524.4018176 878.6986371200001 544 864 586.6666656 832 608 789.3333334399999 608 736L608 640 843.5169184 640C849.3750016 640 855.2053472 639.1957087999999 860.8446368 637.6096608 894.8707136 628.0398272 914.6964128 592.6983584 905.1265792 558.6722816L797.1265792 174.67228160000002C789.3635424 147.07037119999995 764.1897344 128 735.5169184 128L288 128 288 576 448 896ZM483.008 822.976L352 560.96 352 192 735.5169184 192 843.5169184 576 608 576 544 576 544 736C544 769.18886592 532.1510912 792.88668032 505.6 812.8 501.3777696 815.9666726400001 494.5455392 819.22145088 485.19824 822.31760448L483.008 822.976Z',
    }),
  ],
);
export const DeleteIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-delete-icon': true,
    },
  },
  [
    h('g', null, [
      h('path', {
        d: 'M659.2 246.4V185.6c0-32-25.6-57.6-57.6-57.6h-176c-32 0-57.6 25.6-57.6 57.6v57.6H128v57.6h102.4v531.2c0 32 25.6 57.6 57.6 57.6h441.6c32 0 57.6-25.6 57.6-57.6V304H896V246.4H659.2zM422.4 201.6c0-9.6 6.4-16 16-16h147.2c9.6 0 16 6.4 16 16v44.8h-176V201.6zM732.8 822.4c0 9.6-6.4 16-16 16H304c-9.6 0-16-6.4-16-16V304h441.6V822.4z',
      }),
      h('path', {
        d: 'M576 384H640V704H576V384z',
      }),
      h('path', {
        d: 'M384 384H448V704H384V384z',
      }),
    ]),
  ],
);

export const EditIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-edit-icon': true,
    },
  },
  [
    h('path', {
      d: 'M160.07583932 763.37440051h703.84832136v100.54976017H160.07583932zM336.03791965 687.96208035h-100.5497602v-100.54976021l351.92416069-351.92416069 100.54976021 100.5497602zM613.25360852 210.60209379l49.77213129-49.77213128 99.5442626 99.54426259-49.77213131 49.77213129z',
    }),
  ],
);
export const ActiveLikeIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-active-like-icon': true,
    },
  },
  [
    h('path', {
      'fill-rule': 'evenodd',
      d: 'M192 448.9971328L192 896 128 896 128 448.9971328 192 448.9971328ZM288 448L288 896 759.7584608 896C774.0948672 896 786.6817696 886.464816 790.5632896 872.6638592L916.5632896 424.6638592C921.348208 407.6508192 911.4353568 389.9800864 894.4223168 385.1951712 891.6026752 384.402144 888.6875008 384 885.7584608 384L608 384 608 384 608 288C608 234.66666656 586.6666656 192 544 160 524.4018176 145.30136288 492.4018176 134.634696 448 128L288 448Z',
    }),
  ],
);
export const ActiveUnLikeIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-active-un-like-icon': true,
    },
  },
  [
    h('path', {
      'fill-rule': 'evenodd',
      d: 'M192 575.0028672000001L192 128 128 128 128 575.0028672000001 192 575.0028672000001ZM448 896C492.4018176 889.365304 524.4018176 878.6986371200001 544 864 586.6666656 832 608 789.3333334399999 608 736L608 640 843.5169184 640C849.3750016 640 855.2053472 639.1957087999999 860.8446368 637.6096608 894.8707136 628.0398272 914.6964128 592.6983584 905.1265792 558.6722816L797.1265792 174.67228160000002C789.3635424 147.07037119999995 764.1897344 128 735.5169184 128L288 128 288 576 448 896Z',
    }),
  ],
);
export const ToolIconsMap = {
  copy: CopyIcon,
  cite: CiteIcon,
  rebuild: RebuildIcon,
  share: ShareIcon,
  like: LikeIcon,
  unlike: UnLikeIcon,
  delete: DeleteIcon,
  edit: EditIcon,
  activeLike: ActiveLikeIcon,
  activeUnLike: ActiveUnLikeIcon,
} as const;

export type ToolIcons = keyof typeof ToolIconsMap;
